import Vue from 'vue';
const resource = '/workorderitems';

export default {
  cancelReservation(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/cancelreservation`,
      payload
    );
  },
  updateRequestedReserved(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/updaterequestedreserved`,
      payload
    );
  },
  consumeWorkOrderItem(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/consume`,
      payload
    );
  },
};
